'use strict';

require('../../style/index.less');

require('./index.less');

require('../../input/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/select/style/index.tsx
 ** module id = 153
 ** module chunks = 0
 **/